import React from 'react';

export type SummaryType = 'advantage' | 'risk' | 'suggestion';

interface SummarySelectProps {
  type: SummaryType;
  selected?: boolean;
  onSelectChange?: (checked: boolean) => void;
  content: string;
  children?: React.ReactNode;
}

const SummarySelect: React.FC<SummarySelectProps> = ({
  type,
  selected = true,
  onSelectChange,
  content,
  children
}) => {
  const getConfig = (type: SummaryType) => {
    switch (type) {
      case 'advantage':
        return {
          title: '产品优势',
          subtitle: '优势解析',
          bgClass: 'bg-gradient-to-br from-purple-50 to-indigo-50',
          borderClass: 'border-gradient-to-r from-purple-200 to-pink-200'
        };
      case 'risk':
        return {
          title: '风险',
          subtitle: '风险提示',
          bgClass: 'bg-gradient-to-r from-pink-50 to-red-50',
          borderClass: 'border-gradient-to-r from-pink-200 to-red-200'
        };
      case 'suggestion':
        return {
          title: '具体操作建议',
          subtitle: '交易建议',
          bgClass: 'bg-gradient-to-br from-blue-50 to-indigo-50',
          borderClass: 'border-gradient-to-r from-blue-200 to-indigo-200'
        };
      default:
        return {
          title: '产品优势',
          subtitle: '优势解析',
          bgClass: 'bg-gradient-to-br from-purple-50 to-indigo-50',
          borderClass: 'border-gradient-to-r from-purple-200 to-pink-200'
        };
    }
  };

  const config = getConfig(type);

  return (
    <div className={`${config.bgClass} rounded-lg border border-gray-200 p-3 shadow-inner`}>
      {/* 标题行 */}
      <div className="mb-1.5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={selected}
            onChange={e => onSelectChange?.(e.target.checked)}
            className="h-4 w-4 rounded border border-gray-300 bg-blue-600 text-white focus:ring-blue-500"
          />
          <span className="text-base font-semibold text-gray-900">{config.title}</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs font-semibold text-gray-900">{config.subtitle}</span>
        </div>
      </div>

      {/* 内容 */}
      {content && <div className="text-left text-xs leading-relaxed text-gray-900">{content}</div>}
      {children}
    </div>
  );
};

export default SummarySelect;
